import React from "react";
import { useLocation } from "react-router-dom";

const EditForm = () => {
  const Location = useLocation();
  const formvalues = Location.state.state;

  console.log(formvalues, "--->formvalues.state");

  return <>hello world</>;
};

export default EditForm;
